// Import model
import { DataviewBomKitResponse } from '../models/DataviewBomKitResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { BomKit } from '../models/BomKit';
import { DataView } from '../models/DataView';
import { FilterBomKitRequest } from '../models/FilterBomKitRequest';

// Import dependency serializers (for complex types)
import { BomKitSerializer } from './BomKitSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterBomKitRequestSerializer } from './FilterBomKitRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewBomKitResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewBomKitResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewBomKitResponse instance
   */
  static deserialize(json: string): DataviewBomKitResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewBomKitResponse instance
   */
  static fromObject(obj: any): DataviewBomKitResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewBomKitResponse');
    }


    const instance: DataviewBomKitResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        BomKitSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterBomKitRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewBomKitResponse instances
   */
  static deserializeArray(json: string): DataviewBomKitResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewBomKitResponse instance to a JSON string
   */
  static serialize(instance: DataviewBomKitResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewBomKitResponse instance to a plain object
   */
  static toObject(instance: DataviewBomKitResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        BomKitSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterBomKitRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewBomKitResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewBomKitResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
